<template lang="pug">
  // 顧客情報変更
  #change-customer-data
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-button.ml-3.mb-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
      b-form-text.ml-3.mb-2.align-left.text-left.error-message-color(v-for="(error_msg, key) of error_msg_list", :key="key") {{error_msg}}
      b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="updateProc", ok-title="はい", cancel-title="いいえ")
        span 入力内容を送信します。<br>本当によろしいですか？

      b-container(fluid="fluid")
        b-row
          b-col
            .form-inline(:class="title_class")
              h4(:class="title_font_class") ご契約者情報
            b-row.border-top.ml-3.mr-1(v-for="(row_data) of customer_data")
              b-col(:class="customer_title_col_class")
                div(:class="row_data.label_class") {{row_data.label}}
              b-col(:class="customer_input_col_class")
                div(v-if="row_data.label === 'お客様番号'")
                  span {{row_data.value}}
                  b-form-text
                    | ※お客様番号は変更できません
                div(v-else-if="row_data.label === '会社・組織所在地'")
                  b-form-select.mb-2(size="sm", v-model="row_data.value", :class="row_data.form_class", :options="prefectures", @change="updateCompanyNameSearch")
                div(v-else-if="row_data.label === '会社名・組織名'")
                  b-form-input.mb-2(@input="updateCompanyNameSearch", size="sm", v-model="row_data.value", :placeholder="row_data.placeholder", :class="row_data.form_class")
                  p.mb-2 ※会社名を入力すると候補が表示されます。その中から御社名を選択ください。
                  div
                    CompanyNameSearch(v-if="bShowCompanyNameList", :isCompanyListLoading="isCompanyListLoading", :company_list="company_list", @select="setCompanyName")
                div(v-else-if="row_data.label === 'E-mail'")
                  span {{row_data.value}}
                  b-form-text
                    | ※ご契約者情報のE-mailは、
                    router-link.border-bottom.border-primary(:to="{name: 'ChangeMail'}") 設定メニュー => E-mail変更
                    | から行ってください
                div(v-else-if="row_data.label === '住所'")
                  b-form-group.align-content(v-for="(address_data) of customer_address", label-align="right", label-size="sm", label-cols="3", :label="address_data.label", :label-class="address_data.label_class_address")
                    b-form-text(v-if="address_data.label === '都道府県'", size="sm", :class="address_data.form_class") {{customer_data.prefecture.value}}
                    b-form-input(v-else, size="sm", type="text", v-model="address_data.value", :placeholder="address_data.placeholder", :class="address_data.form_class")
                    // エラーメッセージ
                    b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of address_data.error_msg_list") {{error_msg}}
                div(v-else-if="row_data.label === '郵便番号'")
                  .form-inline
                    b-form-input.mb-2(size="sm", type="text", v-model="row_data.value", :placeholder="row_data.placeholder", :class="row_data.form_class")
                    zip-cloud(:zip_code="row_data.value", :prefecture.sync="customer_data.prefecture.value", :city.sync="customer_address.city.value", :address1.sync="customer_address.address1.value", :error_msg.sync="get_address_error")
                  // エラーメッセージ
                  b-form-text.error-message-color(style="margin-top: -5px;") {{get_address_error}}
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of row_data.error_msg_list") {{error_msg}}
                div(v-else)
                  b-form-input.mb-2(size="sm", type="text", v-model="row_data.value", :placeholder="row_data.placeholder", :class="row_data.form_class")
                  // エラーメッセージ
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of row_data.error_msg_list") {{error_msg}}
            b-form-text.border-top.ml-3(style="height: 30px;")

        b-row
          b-col
            .form-inline(:class="title_class")
              h4(:class="title_font_class") 請求書宛名情報
              b-button.mt-2.ml-auto.mr-3(size="sm", variant="outline-info", @click="inputCopy") ご契約者情報からコピー
            b-row.border-top.ml-3.mr-1(v-for="(row_data) of send_invoice")
              b-col(:class="customer_title_col_class")
                div(:class="row_data.label_class") {{row_data.label}}
              b-col(:class="customer_input_col_class")
                div(v-if="row_data.label === '住所'")
                  b-form-group.align-content(v-for="(address_data) of send_invoice_address", label-align="right", label-size="sm", label-cols="3", :label="address_data.label", :label-class="address_data.label_class_address")
                    b-form-input(size="sm", type="text", v-model="address_data.value", :placeholder="address_data.placeholder", :class="address_data.form_class")
                    // エラーメッセージ
                    b-form-text.align-left.text-left.error-message-color(v-if="row_data.label === '住所'", v-for="(error_msg) of address_data.error_msg_list") {{error_msg}}
                div(v-else-if="row_data.label === '郵便番号'")
                  .form-inline(v-if="row_data.label === '郵便番号'")
                    b-form-input.mb-2(size="sm", type="text", v-model="row_data.value", :placeholder="row_data.placeholder", :class="row_data.form_class")
                    zip-cloud(:zip_code="row_data.value", :prefecture.sync="send_invoice_address.bill_prefecture.value", :city.sync="send_invoice_address.bill_city.value", :address1.sync="send_invoice_address.bill_address1.value", :error_msg.sync="get_send_address_error")
                  // エラーメッセージ
                  b-form-text.error-message-color(style="margin-top: -5px;") {{get_send_address_error}}
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of row_data.error_msg_list") {{error_msg}}
                div(v-else)
                  b-form-input.mb-2(size="sm", type="text", v-model="row_data.value", :placeholder="row_data.placeholder", :class="row_data.form_class")
                  // エラーメッセージ
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of row_data.error_msg_list") {{error_msg}}
                  b-form-input.mb-2(v-if="row_data.label === 'E-mail'", size="sm", type="text", v-model="row_data.re_value", :placeholder="row_data.re_placeholder", :class="row_data.form_class")
                  // エラーメッセージ
                  b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of row_data.re_error_msg_list") {{error_msg}}
            .border-top.ml-3
      b-button.ml-3.mt-2(v-b-modal.order_confirm, variant="outline-success", :disabled="isSendButtonDisabled") 送信する
</template>

<script>
import Api from "@/repositories/api";
import CompanyNameSearch from "@/components/CompanyNameSearch.vue";
import Loading from '@/components/Loading';

const S207CustomerChangesRepository = Api.get("s207CustomerChanges");
const LbcCode = Api.get("lbcCode");
import ZipCloud from "@/components/ZipCloud";

export default {
  name: "ChangeCustomerData",
  components: {
    ZipCloud,
    CompanyNameSearch,
    Loading
  },
  data() {
    // const label_class = "address-width";
    // 必須のラベル
    const required_label_class = "py-05 mb-0 float-right required-label-after";

    // 任意のラベル
    const elective_label_class = "py-05 mb-0 float-right elective-label-after";

    // 必須・任意のラベルなし
    const none_label_class = "py-05 mb-0 none-label float-right";

    return {
      title_class: "ml-3 customer-title-bg-color pb-1",
      title_font_class: "font-weight-bold pt-2 mb-0",
      customer_title_col_class: "py-2 px-2 border-right table-title-col-width",
      customer_input_col_class: "py-2 px-2 overflow",

      bShowCompanyNameList: false,
      isCompanyListLoading: false,

      // ご契約者情報
      customer_data: {
        client_no: { label: "お客様番号", placeholder: "", form_class: "middle-form-size", label_class: none_label_class },
        prefecture:{ label: "会社・組織所在地", data: "", value: "", form_class: "middle-form-size", label_class: required_label_class },
        firm_name: { label: "会社名・組織名", value: "", placeholder: "株式会社ネオジャパン", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        firm_kana: { label: "会社名・組織名(かな)", value: "", placeholder: "かぶしきがいしゃねおじゃぱん", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        president_name: { label: "代表者名", value: "", placeholder: "山田　太郎", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        president_kana: { label: "代表者名(かな)", value: "", placeholder: "やまだ　たろう", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        department: { label: "部署名", value: "", placeholder: "営業部", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        person_name: { label: "担当者名", value: "", placeholder: "山田　太郎", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        person_kana: { label: "担当者名(かな)", value: "", placeholder: "やまだ　たろう", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        zip_code: { label: "郵便番号", value: "", placeholder: "2208110（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: required_label_class },
        address: { label: "住所", value: "", error_msg_list: [], label_class: none_label_class },
        tel: { label: "電話番号", value: "", placeholder: "045-123-1234（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: required_label_class },
        fax: { label: "FAX番号", value: "", placeholder: "045-123-1234（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: elective_label_class },
        e_mail: { label: "E-mail", value: "", error_msg_list: [], label_class: none_label_class },
      },

      // LBC企業管理コード
      lbc_office_code: null,

      // 住所
      customer_address: {
        prefecture: { label: "都道府県", value: "", placeholder: "神奈川県", form_class: "short-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        city: { label: "市区町村", value: "", placeholder: "横浜市西区", form_class: "short-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        address1: { label: "丁目番地", value: "", placeholder: "みなとみらい二丁目2-1", form_class: "address-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        address2: { label: "建物名以下", value: "", placeholder: "", form_class: "address-form-size", label_class: "address-width", error_msg_list: [], label_class_address: elective_label_class },
      },

      // ご契約種別
      contract_type: { checked: false, value: "01", error_msg_list: [] },

      // 請求書宛名情報
      send_invoice: {
        bill_firm_name: { label: "会社名・組織名", value: "", placeholder: "株式会社ネオジャパン", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        bill_firm_kana: { label: "会社名・組織名(かな)", value: "", placeholder: "かぶしきがいしゃねおじゃぱん", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        bill_department: { label: "部署名", value: "", placeholder: "営業部", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        bill_person_name: { label: "担当者名", value: "", placeholder: "山田　太郎", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        bill_person_kana: { label: "担当者名(かな)", value: "", placeholder: "やまだ たろう", form_class: "middle-form-size", error_msg_list: [], label_class: required_label_class },
        bill_zip_code: { label: "郵便番号", value: "", placeholder: "2208110（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: required_label_class },
        bill_address: { label: "住所", value: "", placeholder: "", error_msg_list: [], label_class: none_label_class },
        bill_tel: { label: "電話番号", value: "", placeholder: "045-123-1234（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: required_label_class },
        bill_fax: { label: "FAX番号", value: "", placeholder: "045-123-1234（半角数字）", form_class: "short-form-size", error_msg_list: [], label_class: elective_label_class },
        bill_e_mail: { label: "E-mail", value: "", re_value: "", placeholder: "someone@example.com", re_placeholder: "確認のためにもう一度入力してください", form_class: "middle-form-size", error_msg_list: [], re_error_msg_list: [], label_class: required_label_class },
      },

      // 住所
      send_invoice_address: {
        bill_prefecture: { label: "都道府県", value: "", placeholder: "神奈川県", form_class: "short-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        bill_city: { label: "市区町村", value: "", placeholder: "横浜市西区", form_class: "short-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        bill_address1: { label: "丁目番地", value: "", placeholder: "みなとみらい二丁目2-1", form_class: "address-form-size", label_class: "address-width", error_msg_list: [], label_class_address: required_label_class },
        bill_address2: { label: "建物名以下", value: "", placeholder: "", form_class: "address-form-size", label_class: "address-width", error_msg_list: [], label_class_address: elective_label_class },
      },

      company_list: [],
      notFoundMessage: { name:'（該当なし）', office: '一覧に該当する社名がない場合は、会社名を入力欄にご記入ください。', address: '' },

      // 都道府県
      prefectures: this.getPrefectureList(),

      // 住所取得エラーメッセージ
      get_address_error: "",
      // (請求書宛名情報)住所取得エラーメッセージ
      get_send_address_error: "",

      // 画面上部のエラーメッセージ
      error_msg_list: [],

      // 送信ボタン用フラグ
      isSendButtonDisabled: false
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // 入力項目取得
    const vueData = this;

    // お客様情報取得
    S207CustomerChangesRepository.get()
    // 成功時
    .then((response) => {
      // レスポンスデータのお客様情報を全て確認
      Object.keys(response.data.data.customer_info).forEach(function (key) {
        // ご契約者情報の各データがレスポンスにある場合
        if (vueData.customer_data[key] !== undefined) {
          // ご契約者情報の各データが空の場合、入力欄の値は初期値のままにする
          if (response.data.data.customer_info[key] !== '') {
            // 入力欄の値に現在の値を設定
            vueData.customer_data[key].value = response.data.data.customer_info[key];
          }
        }

        // ご契約者情報住所の各データがレスポンスにある場合
        if (vueData.customer_address[key] !== undefined) {
          // 入力欄の値に現在の値を設定
          vueData.customer_address[key].value = response.data.data.customer_info[key];
        }

        // 請求書宛名情報の各データがレスポンスにある場合
        if (vueData.send_invoice[key] !== undefined) {
          // 請求宛名情報の各データが空の場合、入力欄の値は初期値のままにする
          if (response.data.data.customer_info[key] !== '') {
            // 入力欄の値に現在の値を設定
            vueData.send_invoice[key].value = response.data.data.customer_info[key];
          }
          // 確認用メールアドレスの入力欄の値に現在の値を設定
          if (key === 'bill_e_mail') {
            vueData.send_invoice[key].re_value = response.data.data.customer_info[key];
          }
        }

        // 請求書宛名情報住所の各データがレスポンスにある場合
        if (vueData.send_invoice_address[key] !== undefined) {
          // 入力欄の値に現在の値を設定
          vueData.send_invoice_address[key].value = response.data.data.customer_info[key];
        }
      });
    })
    // 失敗時
    .catch((error) => {
      // httpステータスコードが403の場合（権限エラー）
      if (error.response.status === 403) {
        // アプリケーションエラー画面へ遷移する
        this.$router.push({
          name: 'SupportApplicationError',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: this.forbidden_message
          }
        })
      }

      // 共通のエラー処理（システムエラー画面へ遷移）
      this.apiError(error, "画面表示処理", "Support")
    })
    .finally(() => [
      // 読み込み完了
      this.isLoading = false
    ])
  },
  methods: {
    /**
     * ご契約者情報コピー処理
     */
    inputCopy() {
      // 入力項目取得
      const vueData = this;

      // 請求書宛名情報の入力欄全てに対して処理を行う
      Object.keys(vueData.send_invoice).forEach(function (sendInvoiceKey) {
        // キーから「bill_」を取り除く
        let customerDataKey = sendInvoiceKey.replace("bill_", "");
        // メール以外の場合ご契約者情報からコピー
        if (customerDataKey !== "e_mail") {
          vueData.send_invoice[sendInvoiceKey].value = vueData.customer_data[customerDataKey].value;
        }
      });

      // 請求書宛名情報住所の入力欄全てに対して処理を行う
      Object.keys(vueData.send_invoice_address).forEach(function (sendInvoiceKey) {
        // キーから「bill_」を取り除く
        let customerDataKey = sendInvoiceKey.replace("bill_", "");

        vueData.send_invoice_address[sendInvoiceKey].value = vueData.customer_address[customerDataKey].value;
      });
    },
    /**
     * エラーメッセージ表示処理
     */
    showErrorMsg(error_msg) {
      // 画面上部にエラーメッセージを表示する
      this.error_msg_list.push(error_msg);

      // 画面一番上へスクロールする
      this.pageTopScroll();
    },
    /**
     * お客様情報変更処理
     */
    updateProc() {
      // 画面のインスタンスオブジェクト取得
      const vueData = this;

      // リクエストパラメータ用データ初期化
      let arInputData = {customer_info: {}}

      // ご契約者情報
      Object.keys(vueData.customer_data).forEach(function (key) {
        // 顧客番号とE-mailを除く / 住所は別途処理する
        if (key !== "client_no" && key !== "address" && key !== "e_mail") {
          arInputData["customer_info"][key] = vueData.customer_data[key].value;
        }
      });

      // LBC企業管理コード
      arInputData["customer_info"]['lbc_office_code'] = this.lbc_office_code || '';

      // ご契約者情報住所
      Object.keys(vueData.customer_address).forEach(function (key) {
        // 都道府県以外処理する
        if (key !== 'prefecture') {
          arInputData["customer_info"][key] = vueData.customer_address[key].value;
        }
      });

      // 請求書宛名情報
      Object.keys(vueData.send_invoice).forEach(function (key) {
        // 住所については省略
        if (key !== "bill_address") {
          arInputData["customer_info"][key] = vueData.send_invoice[key].value;

          // 請求先emailは再度入力した内容もデータに入れる
          if (key === "bill_e_mail") {
            arInputData["customer_info"]["re_bill_e_mail"] = vueData.send_invoice['bill_e_mail'].re_value;
          }
        }
      });

      // 請求書宛名情報住所
      Object.keys(vueData.send_invoice_address).forEach(function (key) {
        arInputData["customer_info"][key] = vueData.send_invoice_address[key].value;
      });

      // 「送信する」ボタンをロックする
      this.isSendButtonDisabled = true;

      // 更新処理呼び出し
      S207CustomerChangesRepository.post(arInputData)
      // 更新処理成功
      .then (() => {
        this.$router.push ({
          name: 'ShowCustomerInfo'
        })
      })
      // 入力値エラー処理
      .catch((error) => {
        // 「送信する」ボタンをロックを解除する
        this.isSendButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(error, '変更処理', "Support")

        // 画面上部のエラーメッセージリセット
        this.error_msg_list = [];

        // 既存のエラーメッセージをリセット(お客様情報)
        for (let key in vueData.customer_data) {
          vueData.customer_data[key].error_msg_list = [];
        }

        // 既存のエラーメッセージをリセット(お客様情報住所)
        for (let key in vueData.customer_address) {
          vueData.customer_address[key].error_msg_list = [];
        }

        // 既存のエラーメッセージをリセット(請求書宛名情報)
        for (let key in vueData.send_invoice) {
          vueData.send_invoice[key].error_msg_list = [];
          // 請求先emailは再度入力した内容もデータに入れる
          if (key === 'bill_e_mail') {
            vueData.send_invoice['bill_e_mail'].re_error_msg_list = [];
          }
        }

        // 既存のエラーメッセージをリセット(請求書宛名情報住所)
        for (let key in vueData.send_invoice_address) {
          vueData.send_invoice_address[key].error_msg_list = [];
        }

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 共通のエラーメッセージ表示処理
          this.showErrorMsg(this.forbidden_message);
        }
        else {
          // エラーリストの読み込み
          const arErrorList = error.response.data.error_list;
          // 各エラーメッセージを画面に埋め込む
          arErrorList.forEach((objError) => {
            if (vueData.customer_data[objError.target] !== undefined) {
              vueData.customer_data[objError.target].error_msg_list.push(objError.error_msg);
            }
            if (vueData.customer_address[objError.target] !== undefined) {
              vueData.customer_address[objError.target].error_msg_list.push(objError.error_msg);
            }
            if (vueData.send_invoice[objError.target] !== undefined) {
              vueData.send_invoice[objError.target].error_msg_list.push(objError.error_msg);
            }
            if (vueData.send_invoice_address[objError.target] !== undefined) {
              vueData.send_invoice_address[objError.target].error_msg_list.push(objError.error_msg);
            }
            if (objError.target === 're_bill_e_mail') {
              vueData.send_invoice['bill_e_mail'].re_error_msg_list.push(objError.error_msg);
            }
            if (objError.target === 'check_data_updated') {
              // 共通のエラーメッセージ表示処理
              this.showErrorMsg(objError.error_msg);
            }
          })
        }
      })
    },
    // 会社名候補一覧の取得
    getCompanyInfo () {
      // リクエストパラメータ
      const arParam = {
        cmd: 'search', // コマンド
        s: this.customer_data.prefecture.value + ' ' + this.customer_data.firm_name.value // 検索キーワード
      }

      // 会社名候補一覧の初期化
      this.company_list = []
      // LBC企業管理コードの初期化
      this.lbc_office_code = ''

      // ローディング開始
      this.isCompanyListLoading = true

      // リクエスト送信
      LbcCode.get(arParam)
        // API呼び出し成功時
        .then((response) => {
          // 各会社名候補の情報を保存していく
          for (let index in response.data.list) {
            this.company_list.push({
              name: response.data.list[index].lbc_company_name,
              office: response.data.list[index].lbc_office_name,
              address: response.data.list[index].lbc_company_addr,
              lbc_office_code: response.data.list[index].lbc_office_id
            })
          }

          // 会社名候補が0件の場合
          if (this.company_list.length === 0) {
            // 会社名候補一覧を非表示
            this.bShowCompanyNameList = false;
          }
          else {
            // 会社名候補一覧を表示
            this.bShowCompanyNameList = true
          }
        })
        // 失敗時
        .catch(() => {
          // 会社名候補一覧を非表示
          this.bShowCompanyNameList = false;
        })
        .finally(()=> {
          // 該当する会社名がないメッセージを追加する
          this.company_list.push(this.notFoundMessage)
          // ローディング終了
          this.isCompanyListLoading = false
        })
    },
    // 選択した会社名候補を保存する
    setCompanyName(company) {
      // 会社名候補一覧を非表示
      this.bShowCompanyNameList = false

      // 選択された会社名が「（該当なし）」でない場合
      if (company.name !== '（該当なし）') {
        // 選択した会社名を設定する
        this.customer_data.firm_name.value = company.name
      }
      // 選択された会社のLBC企業管理コードを設定する
      this.lbc_office_code = company.lbc_office_code
    },
    // 会社名候補一覧の表示・非表示の切り替え
    updateCompanyNameSearch() {
      // タイマーをリセットして実行待ちのタイマーをクリアする
      clearTimeout(this.timer);
      // 会社名・組織名を入力後1秒後に実行する
      this.timer = setTimeout(() => {
        // 都道府県が選択されている かつ 会社名・組織名が２文字以上入力されている場合
        if (this.customer_data.prefecture.value !== '' && this.customer_data.firm_name.value.length > 1) {
          // 会社名候補一覧取得
          this.getCompanyInfo()
        }
        else {
          // 会社名候補一覧を非表示
          this.bShowCompanyNameList = false;
        }
      }, 1000);
    },
  }
}
</script>

<style scoped>
.none-label {
  padding-right: 48px;
}
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-title-col-width {
  max-width: 230px;
}
.table-now-data-col-width {
  max-width: 230px;
}
.address-form-size {
  max-width: 350px;
}
.short-form-size {
  width: 185px;
}
.overflow {
  overflow: auto;
}
.explanation-remarks {
  margin-bottom: -13px;
}
.now-data-font {
  color: #c0c0c0;
  /*color: #6c757d;*/
}
.middle-form-size {
   max-width: 500px;
}
</style>
